import {useActions, useGetters, useMutators, useState} from './_map';
import CameraMediaObjectPopup from "@/js/Components/MapPopup/CameraMediaObjectPopup.vue";

export default {
    namespaced: true,
    state: {
        ...useState(),
        popupComponent: CameraMediaObjectPopup,
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
